import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

// component
import Helmet from 'components/helmet/helmet';

const noContextMenu = (e) => { e.preventDefault(); e.stopPropagation(); return false };

export default function Guidebook() {
	const { t } = useTranslation();

	// 各資料は複数の画像（表紙・中身など）を横／縦の向きに応じて並べる
	const items = [
		{
			key: 'guidebook_item_pamphlet',
			imgs: [
				{ src: 'img-guidebook-pamphlet-cover.jpg', orient: 'v' },
				{ src: 'img-guidebook-pamphlet-inside.jpg', orient: 'h' },
			],
		},
		{
			key: 'guidebook_item_leaflet',
			fit: 'width',
			imgs: [
				{ src: 'img-guidebook-leaflet-open.jpg', orient: 'h' },
				{ src: 'img-guidebook-leaflet-fold.jpg', orient: 'h' },
			],
		},
		{
			key: 'guidebook_item_miniguide',
			imgs: [
				{ src: 'img-guidebook-miniguide-cover.jpg', orient: 'v' },
				{ src: 'img-guidebook-miniguide-inside.jpg', orient: 'h' },
			],
		},
		{
			key: 'guidebook_item_books',
			imgs: [
				{ src: 'img-guidebook-books-iron.jpg', orient: 'v' },
				{ src: 'img-guidebook-books-ship.jpg', orient: 'v' },
				{ src: 'img-guidebook-books-coal.jpg', orient: 'v' },
			],
		},
		{
			key: 'guidebook_item_beginner',
			imgs: [
				{ src: 'img-guidebook-beginner-cover.jpg', orient: 'v' },
				{ src: 'img-guidebook-beginner-inside.jpg', orient: 'h' },
			],
		},
		{
			key: 'guidebook_item_accessmap',
			imgs: [
				{ src: 'img-guidebook-accessmap.jpg', orient: 'h' },
			],
		},
	];

	return (
		<>
			<Helmet>
				<title>{t('common_guidebook')} : {t('common_ihic')}</title>
			</Helmet>
			<h1 className="c-pageHeader">
				<div className="c-pageHeader__container">
					<span className="c-pageHeader__jp">{t('common_guidebook')}</span>
					<span className="c-pageHeader__eng">GUIDEBOOK</span>
				</div>
			</h1>

			<div className="c-topicPath c-block">
				<ol className="c-topicPath__list">
					<li className="c-topicPath__item"><Link to="/" className="c-topicPath__anchor">{t('common_home')}</Link></li>
					<li className="c-topicPath__item"><span className="c-topicPath__separator" style={{ backgroundImage: `url(${require('assets/img/rocket-on/bullet-topicPath.svg').default})`}}></span>{t('common_guidebook')}</li>
				</ol>
			</div>

			<div className="p-guidebook c-block c-block--w740">

				<p className="p-guidebook__lead">{t('guidebook_text')}</p>

				<ol className="p-guidebook__list">
					{items.map((item) => (
						<li className="p-guidebook-card" key={item.key}>
							<div className={`p-guidebook-card__gallery${item.fit === 'width' ? ' p-guidebook-card__gallery--sameWidth' : ''}`}>
								{item.imgs.map((img) => (
									<p className={`p-guidebook-card__img p-guidebook-card__img--${img.orient}`} key={img.src}>
										<img onContextMenu={noContextMenu} src={require(`assets/img/rocket-on/${img.src}`)} alt={t(item.key)} />
									</p>
								))}
							</div>
							<p className="p-guidebook-card__caption">{t(item.key)}</p>
						</li>
					))}
				</ol>

			</div>

		</>
	);
}
